import addonItem from 'html/addon/addon-item.html';
import App from 'app/app.js';
import ProductPersonalizer from 'app/store/ProductPersonalizer.js';

function AddOnItemController() {
  const ctrl = this;

  this.isCustomizable = function (item) {
    return !!item.personalizerEnabled && item.productPersonalizer === ProductPersonalizer.LNSSTextBasedPersonalizer;
  };

  this.emit = function (type) {
    ctrl.onEmitValue({ type, item: ctrl.addon.item });
  };

  this.showZoomAddOn = function (item) {
    ctrl.onShowZoomAddOn({ item });
  };
}

App.component('ltAddOnItem', {
  template: addonItem,
  bindings: {
    addon: '<',
    packageAdded: '<',
    onEmitValue: '&',
    onShowZoomAddOn: '&'
  },
  controller: AddOnItemController,
  controllerAs: 'ctrl'
});
